import axios from '@/http'
import * as dd from 'dingtalk-jsapi';

export default{
  state:{
    userInfo:{},
    token:'',
      corpId: 'dingd951b7448023172c35c2f4657eb6378f', //鑫磊
    // corpId: '',
    // corpId: 'ding567e20db104f5efe35c2f4657eb6378f', //煜祺
  },
  actions:{
    // getCorpId({commit}) {
    //     return new Promise((resolve, reject) => {
    //         axios.get('/dingding/getCorpId').then(res => {
    //             console.log(res.data);
    //             commit('set_corpId', res.data);
    //             resolve();
    //         }).catch(err => {
    //             reject(err);
    //         })
    //     })
    // },
    getToken({commit}) {
      return new Promise((resolve, reject) => {
        // axios.get('/dingding/getToken', {
        //   params: {
        //     code: '111111',
        //     corpId: this.state.user.corpId
        //   }
        // }).then(res => {
        //   commit('set_userInfo', res.data);
        //   commit('set_token', res.data.token_id);
        //   resolve();
        // }).catch(err=>{
        //   reject(err);
        // })
        dd.ready(() => {
          dd.runtime.permission.requestAuthCode({
            corpId: this.state.user.corpId,
            onSuccess: res => {
              axios.get('/dingding/getToken', {
                params: {
                  code: res.code,
                  corpId: this.state.user.corpId
                }
              }).then(res => {
                commit('set_userInfo', res.data);
                commit('set_token', res.data.token_id);
                resolve();
              }).catch(err=>{
                reject(err);
              })
            },
            onFail: err=>{
              reject(err)
            }
          });
        });
      })
    },
    getDingConfig({ commit }){
      axios.get('/dingding/getJSAPI', {
        params: {
          url: window.location.href.split('#')[0],
          corpId: this.state.user.corpId
        }
      }).then(res => {
        const data=res.data;
        dd.config({
          agentId: data.agentId, // 必填，微应用ID
          corpId: data.corpId,//必填，企业ID
          timeStamp: data.timeStamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名
          type: 0 ,   //选填。0表示微应用的jsapi,1表示服务窗的jsapi；不填默认为0。该参数从dingtalk.js的0.8.3版本开始支持
          jsApiList: [
            'biz.contact.complexPicker',
          ] // 必填，需要使用的jsapi列表，注意：不要带dd。
        });
      })
    }
  },
  mutations:{
    set_token(state, data){
      state.token=data
    },
    set_userInfo(state, data) {
      state.userInfo = data
    },
    set_corpId(state, data) {
      state.corpId = data
    },
  }
}
